import React from 'react';
import { Facebook, Instagram, Share2 } from 'lucide-react';

const FACEBOOK_URL = 'https://www.facebook.com/profile.php?id=61580895101388';
const INSTAGRAM_URL = 'https://www.instagram.com/Trucknsendit';

export const SocialFollowBar = () => (
  <div className="bg-gradient-to-r from-[#1e3a5f] to-[#2a4d7a] text-white py-3">
    <div className="container mx-auto px-4 flex items-center justify-center gap-4 text-sm">
      <span className="font-medium hidden sm:inline">Follow us for load updates:</span>
      <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer"
        className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-full transition-colors"
        data-testid="follow-facebook">
        <Facebook className="w-4 h-4" /> Facebook
      </a>
      <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer"
        className="flex items-center gap-1.5 bg-white/10 hover:bg-white/20 px-3 py-1.5 rounded-full transition-colors"
        data-testid="follow-instagram">
        <Instagram className="w-4 h-4" /> Instagram
      </a>
    </div>
  </div>
);

export const ShareLoadButtons = ({ load }) => {
  if (!load) return null;

  const loadUrl = `https://www.trucknsendit.com/load/${load.id}`;
  const text = `Check out this freight load: ${load.pickup_location} to ${load.dropoff_location} — ${load.cargo_type}. Quote now on Truckn Send It!`;

  const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(loadUrl)}&quote=${encodeURIComponent(text)}`;
  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(`${text}\n${loadUrl}`);
      alert('Link copied! Paste it on any social platform.');
    } catch {
      prompt('Copy this link:', `${text}\n${loadUrl}`);
    }
  };

  return (
    <div className="flex items-center gap-2" data-testid="share-load-buttons">
      <span className="text-xs text-gray-500 font-medium">Share:</span>
      <a href={fbShareUrl} target="_blank" rel="noopener noreferrer"
        className="flex items-center gap-1 text-xs bg-blue-600 text-white px-2.5 py-1.5 rounded-full hover:bg-blue-700 transition-colors"
        data-testid="share-facebook">
        <Facebook className="w-3.5 h-3.5" /> Facebook
      </a>
      <button onClick={copyLink}
        className="flex items-center gap-1 text-xs bg-gray-600 text-white px-2.5 py-1.5 rounded-full hover:bg-gray-700 transition-colors"
        data-testid="share-copy-link">
        <Share2 className="w-3.5 h-3.5" /> Copy Link
      </button>
    </div>
  );
};

export default SocialFollowBar;
